// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
import { LoaderService } from '../utils/loader.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoaderInterCeptService implements HttpInterceptor {
	requestCounter = 0;

	constructor(public loaderService: LoaderService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.loaderGosterilsinMi(req)) {
			this.requestCounter++;
			// console.log(
			// 	`%c + ${this.requestCounter}  %c (${req.url})`,
			// 	'background: #444; color: #bada55',
			// 	'background: #444; color: #995555'
			// );
			Promise.resolve(null).then(() => this.loaderService.show());
		}

		return next.handle(req).pipe(
			finalize(() => {
				if (this.loaderGosterilsinMi(req)) {
					this.requestCounter--;
					// console.log(
					// 	`%c - ${this.requestCounter}  %c (${req.url})`,
					// 	'background: #444; color: #ff5555',
					// 	'background: #444; color: #995555'
					// );
				}

				if (this.requestCounter <= 0) {
					this.loaderService.hide();
				}
			})
		);
	}

	private loaderGosterilsinMi(req: HttpRequest<any>): boolean {
		const urlParts = req.url.split('/');
		const endpoint = urlParts[urlParts.length - 1];
		if (endpoint === 'MusteriKrediLimitleriGetir') {
			return false;
		}

		// Toplu hizmet formu kaydetmede hizmet kodu 2 (saklama) varsa sistem loader'ı gösterme.
		if (endpoint === 'TopluHizmetFormKaydet' && this.saklamaHizmetiIceriyorMu(req.body)) {
			return false;
		}

		return true;
	}

	private saklamaHizmetiIceriyorMu(body: any): boolean {
		const detaylar = body?.tblFiloHizmetDetay;
		if (!Array.isArray(detaylar)) {
			return false;
		}

		return detaylar.some(detay => {
			const anaKalemSaklama = +detay?.lngUrunKod === 2 && +detay?.bytDurum === 1;
			const altHizmetteSaklama =
				Array.isArray(detay?.tblFiloHizmetDetayHizmet) &&
				detay.tblFiloHizmetDetayHizmet.some(hizmet => +hizmet?.lngHizmetKod === 2 && +hizmet?.bytDurum === 1);
			return anaKalemSaklama || altHizmetteSaklama;
		});
	}
}
